import { render } from "./structuredDeposits1.vue?vue&type=template&id=265b42d6&scoped=true"
import script from "./structuredDeposits1.vue?vue&type=script&lang=js"
export * from "./structuredDeposits1.vue?vue&type=script&lang=js"

import "./structuredDeposits1.vue?vue&type=style&index=0&id=265b42d6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265b42d6"]])

export default __exports__